import React from "react";
import LogoNim from "../../src/images/logo-nim.png";
import { Logo } from "../components/Navbar/NavbarElements";
import { Icon, Container } from "../components/Quote/QuoteElements";

export default function ImpressumPage() {
  return (
    <Container>
      <Icon to="/">
        <Logo src={LogoNim} />
      </Icon>
      <div className="impressum-container">
        <div className="impressum-wrapper">
          <p className="title">IMPRESSUM</p>
          <div>
            <p className="impressum">
              NIM Agency
              <br />
              Berlin, Germany
              <br />
              13349 <br />
              E-Mail: agencynim@gmail.com
              <br />
              Internet: <a target="_blank">https://www.nimagency.com/</a>
            </p>
          </div>
          <div></div>
        </div>
      </div>
    </Container>
  );
}
